import React from 'react';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  border: {
    borderBottom: '2px solid lightgray',
    width: '100%',
  },
  divider: {
    width: '50%',
    alignSelf: 'center',
  },
  content: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    fontWeight: 500,
    fontSize: 22,
    color: 'lightgray',
  },
}));

const SectionDivider = () => {
  const classes = useStyles();
  return (
    <Grid container spacing={3} style={{ padding: 20 }}>
      <Grid item xs></Grid>
      <Grid item xs={6}>
        <div className={classes.container}>
          <div className={classes.border} />
          <div className={classes.border} />
        </div>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
};
export default SectionDivider;
